const map = {
	"./custom_fields/AIUsageField": 57149,
	"./custom_fields/AIUsageField.js": 57149,
	"./custom_fields/BookSeriesField": 15668,
	"./custom_fields/BookSeriesField.js": 15668,
	"./custom_fields/ContentWarningField": 2653,
	"./custom_fields/ContentWarningField.js": 2653,
	"./custom_fields/DashboardEnabledField": 84499,
	"./custom_fields/DashboardEnabledField.js": 84499,
	"./custom_fields/EditionField": 66680,
	"./custom_fields/EditionField.jsx": 66680,
	"./custom_fields/ImprintISBNField": 75157,
	"./custom_fields/ImprintISBNField.js": 75157,
	"./custom_fields/ImprintPagesField": 9005,
	"./custom_fields/ImprintPagesField.js": 9005,
	"./custom_fields/ImprintPlaceField": 72188,
	"./custom_fields/ImprintPlaceField.js": 72188,
	"./custom_fields/ImprintTitleField": 50519,
	"./custom_fields/ImprintTitleField.js": 50519,
	"./custom_fields/JournalISSNField": 28500,
	"./custom_fields/JournalISSNField.jsx": 28500,
	"./custom_fields/JournalIssueField": 38078,
	"./custom_fields/JournalIssueField.js": 38078,
	"./custom_fields/JournalPagesField": 49470,
	"./custom_fields/JournalPagesField.jsx": 49470,
	"./custom_fields/JournalTitleField": 66703,
	"./custom_fields/JournalTitleField.jsx": 66703,
	"./custom_fields/JournalVolumeField": 99947,
	"./custom_fields/JournalVolumeField.jsx": 99947,
	"./custom_fields/Notes": 36845,
	"./custom_fields/Notes.js": 36845,
	"./custom_fields/SponsoringInstitutionField": 5498,
	"./custom_fields/SponsoringInstitutionField.jsx": 5498,
	"./custom_fields/UserDefinedTags": 15348,
	"./custom_fields/UserDefinedTags.js": 15348,
	"./custom_fields/Volumes": 74059,
	"./custom_fields/Volumes.js": 74059
};



function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then((id) => (__webpack_require__(id)));
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(() => {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 54555;
module.exports = webpackAsyncContext;